import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faCheckCircle, faExclamationTriangle, faTimesCircle, faTimes } from "@fortawesome/free-solid-svg-icons";

const CustomAlert = ({ message, type = "info", duration = 3000, onClose }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      if (onClose) onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  if (!visible) return null;

  const alertStyles = {
    info: "bg-[#0288d1] text-white",
    success: "bg-[#2e7d32] text-white",
    warning: "bg-[#ed6c02] text-white",
    error: "bg-[#ff2c2c] text-white",
  };

  const iconColors = {
    info: "text-white",
    success: "text-white",
    warning: "text-white",
    error: "text-white",
  };

  const icons = {
    info: faInfoCircle,
    success: faCheckCircle,
    warning: faExclamationTriangle,
    error: faTimesCircle,
  };

  return (
    <div
      className={`fixed z-[999] left-[50%] top-[10%] transform -translate-x-1/2 p-4 rounded-lg shadow-lg transition-all duration-300 ease-in-out ${alertStyles[type]} ${
        visible ? "opacity-100 scale-100" : "opacity-0 scale-95"
      }`}
    >
      <div className="flex items-center justify-between">
        {/* Icon and Message */}
        <div className="flex items-center gap-3">
          <div className={`flex items-center justify-center w-10 h-10 rounded-full ${iconColors[type]}`}>
            <FontAwesomeIcon icon={icons[type]} className="text-xl" />
          </div>
          <span className="text-base font-semibold">
             {message}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CustomAlert;